// import Axios from 'axios'
import { getAuth } from 'firebase/auth'
import router from '@/lib/router'
import { fb } from '@/lib/api/firebase'

const API_URL = import.meta.env.VITE_API_URL || process.env.API_URL

const authCheck = async () => {
	const auth = getAuth()
	if (!auth?.currentUser) {
		throw new Error(JSON.stringify({code: 400, message: `Session expired. Please log in again.`}))
	}

	let token
	try {
		token = await auth.currentUser?.getIdToken()
	} catch (error) {
		try {
			token = await auth.currentUser?.getIdToken(true)
		} catch (error) {
			throw new Error(JSON.stringify({code: 400, message: `Session expired. Please log in again.`}))
		}
	}
	if (!token) {
		throw new Error(JSON.stringify({code: 400, message: `Session expired. Please log in again.`}))
	}

	return token
}

export const API = {

	controller : new AbortController(),

	async get(path, params, options = {}, withAuth = true, headers = {}, cancel = false, nocache = false) {
		if (withAuth) {
			let token = await authCheck()
			headers.Authorization = `Bearer ${token}`
		}

		if (cancel) {
			// const source = Axios.CancelToken.source()
			// const cancelToken = source.token
			// options.cancelToken = cancelToken
			// this.requestSource = source
		}

		if (nocache) {
			headers.cache = 'no-store'
			params = params || {}
			params._timestamp_ = (new Date()).getTime()
		}

		return this._request({
			method: 'GET',
			url: path,
			params,
			headers,
			...options,
		})
	},

	async post(path, data, options = {}, withAuth = true, headers = {}, cancel = false) {
		if (withAuth) {
			let token = await authCheck()
			headers.Authorization = `Bearer ${token}`
		}

		if (cancel) {
			// const source = Axios.CancelToken.source()
			// const cancelToken = source.token
			// options.cancelToken = cancelToken
			// this.requestSource = source
		}

		return this._request({
			method: 'POST',
			url: path,
			data,
			headers,
			...options,
		})
	},

	async patch(path, data, options = {}, withAuth = true, headers = {}, cancel = false) {
		if (withAuth) {
			let token = await authCheck()
			headers.Authorization = `Bearer ${token}`
		}

		if (cancel) {
			const source = Axios.CancelToken.source()
			const cancelToken = source.token
			options.cancelToken = cancelToken
			this.requestSource = source
		}

		return this._request({
			method: 'PATCH',
			url: path,
			data,
			headers,
			...options,
		})
	},

	async delete(path, options = {}, withAuth = true, headers = {}, cancel = false) {
		if (withAuth) {
			let token = await authCheck()
			headers.Authorization = `Bearer ${token}`
		}

		if (cancel) {
			const source = Axios.CancelToken.source()
			const cancelToken = source.token
			options.cancelToken = cancelToken
			this.requestSource = source
		}

		return this._request({
			method: 'DELETE',
			url: path,
			headers,
			...options,
		})
	},

	_request(opts, cancel) {
		const signal = this.controller.signal
		// const axios = Axios.create({
		// 	// adapter: cacheAdapterEnhancer(Axios.defaults.adapter),
		// })

		// axios.interceptors.request.use(async (config) => {
		// 	const appHeaders = await fb.appHeaders()
		// 	config.headers = {
		// 		...config.headers,
		// 		...appHeaders,
		// 	}

		// 	return config
		// })
		if (cancel ){
			this.controller.abort()
		}


		return new Promise(async (resolve, reject) => {
			const { url, data, params, ...rest } = opts
			const body = data ? JSON.stringify(data) : undefined
			rest.body = body
			const appHeaders = await fb.appHeaders()
			rest.headers = {
				...rest.headers,
				...appHeaders,
				'Content-Type': 'application/json'
			}
			rest.signal = signal
			const qs = new URLSearchParams(params).toString()

console.log({ url, rest, })

			fetch(`${API_URL}${url}?${qs}`, rest)
				.then(async r => {
					if (!r.ok) {
						const error = await r.json().catch(() => ({}))
						throw { response: { data: error, status: resolve.status }}
					}
					return r.json()
				})
				.then(resolve)
				.catch(err => {
					if (err.name === 'AbortError') {
						this.requestSource = undefined
						return resolve
					}

					if (err?.response?.data) {
						return reject(err.response.data)
					}
					return reject(err)
				})
		})
/*
		return new Promise((resolve, reject) => {
			axios({ ...opts, })
				.then(r => r.data)
				.then(resolve)
				.catch(err => {
					if (Axios.isCancel(err)) {
						this.requestSource = undefined
						return resolve()
					}

					if (err && err.response && err.response.data) {
						return reject(err.response.data)
					}
					return reject(err)
				})
		})
				*/
	},
}
